"use client"
import {useContext, createContext, useEffect, useState, useCallback, useMemo} from 'react';

type  childrenType ={
    children:  React.ReactNode;
}

type networkStatusContextType = {
    isOnline: boolean
    timestamp: number
}


const NetworkContext = createContext<networkStatusContextType | null>(null)

export const NetworkProvider = ({children} : childrenType)=>{
    const [isOnline, setOnline] = useState<boolean>(() : boolean =>{
        return true
    })

    const [timestamp, setTimestamp] = useState<number>(0)

    const setOnlineToTrue = useCallback(() : void=>{
        setOnline(true)
    }, [])
    const setOnlineToFalse = useCallback(() : void=>{
        setTimestamp(Date.now());
        setOnline(false)
    }, [])

    useEffect(()=>{
        window.addEventListener('online', setOnlineToTrue)
        window.addEventListener('offline', setOnlineToFalse)

        return ()=>{
            window.removeEventListener('online', setOnlineToTrue)
            window.removeEventListener('offline', setOnlineToFalse)
        }
    }, [setOnlineToTrue,setOnlineToFalse ])

    const data = useMemo(() => {
        return {
            isOnline,
            timestamp
        }
    }, [timestamp, isOnline]);

    return <NetworkContext.Provider value={data}>{children}</NetworkContext.Provider>
}

export const useNetworkCheck = ()=>{
    const context = useContext(NetworkContext);
    if(!!!context){
        throw Error("useNetworkCheck must be used inside of NetworkProvider");
    }

    return context;
} 